import { unnull } from '@/shared/lib/converters.ts';
import type { TExcursionFiltersState } from '@/entities/filter/store/excursion';
import type { LocationQueryRaw } from 'vue-router';
import { DEFAULT_SORTING } from '@/entities/filter/store/const/config.ts';

// Для разделения фильтров формата проведения туров было
// внедрено дублирование функционала. В сторе заведено еще одно состояние tourFormat
// которое дублирует состояние type у фильтров формата экскурсий
// в апи и в урлах значение из tourFormat приравнивается к апи полю type
function buildTypeParam(searchState: TExcursionFiltersState): string | undefined {
  const { type, tourFormat } = searchState;

  if (type && type.length) {
    return type.join(',');
  }

  if (tourFormat && tourFormat.length) {
    const unique = Array.from(new Set(tourFormat));

    return unique.join(',');
  }

  return undefined;
}

export const excursionBuildQueryFilterParams = (searchState: TExcursionFiltersState): LocationQueryRaw => {
  return {
    end_date: unnull(searchState.date.to),
    end_duration: unnull(searchState.duration[1]),
    end_price: unnull(searchState.price[1]),
    movement_type: searchState.movementTypes?.length ? searchState.movementTypes.join(',') : undefined,
    persons_count: searchState.date.persons > 1 ? searchState.date.persons : undefined,
    start_date: unnull(searchState.date.from),
    start_duration: unnull(searchState.duration[0]),
    start_price: unnull(searchState.price[0]),
    type: buildTypeParam(searchState),
    children_allowed: searchState.childrenAllowed ? String(searchState.childrenAllowed) : undefined,
    start_time_interval: searchState.startTimeInterval?.length ? searchState.startTimeInterval.join(',') : undefined,
    duration_interval: searchState.durationInterval?.length ? searchState.durationInterval.join(',') : undefined,
    sorting: searchState.sorting !== DEFAULT_SORTING ? unnull(searchState.sorting) : undefined,
  };
};
